<template>
  <div class="columns is-multiline">
    <div class="column is-narrow" v-for="(recapMontant, index) in getTabRecap" :key="index">
      <div class="card-content has-background-white">
        <b-icon
          icon="circle"
          size="is-small"
          :type="recapMontant.colorRond">
        </b-icon>
        {{ $t(recapMontant.libelle )}} :
        <span class="right">{{ recapMontant.montant | formatDevise }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import {
  ETAT_ENATTENTE,
  ETAT_NONRENOUVELEE,
  ETAT_RENOUVELEE,
  ETAT_TACITE,
  ETAT_ENCOURS,
} from '@/configuration/devisConf';

export default {
  props: {
    lignesCommande: {
      type: Array,
      required: true,
    },
  },
  computed: {
    getTabRecap() {
      return [
        {
          colorRond: 'is-aRenouveler',
          libelle: 'renouvellementCommande.etat.aRenouveler',
          montant: this.getMontantForEtat(ETAT_ENATTENTE),
        },
        {
          colorRond: 'is-primary',
          libelle: 'renouvellementCommande.etat.renouvele',
          montant: this.getMontantForEtat(ETAT_RENOUVELEE),
        },
        {
          colorRond: 'is-tacite',
          libelle: 'renouvellementCommande.etat.tacite',
          montant: this.getMontantForEtat(ETAT_TACITE),
        },
        {
          colorRond: 'is-nonRenouvelee',
          libelle: 'renouvellementCommande.etat.nonRenouvele',
          montant: this.getMontantForEtat(ETAT_NONRENOUVELEE),
        },
        {
          colorRond: 'is-enCours',
          libelle: 'renouvellementCommande.etat.enCours',
          montant: this.getMontantForEtat(ETAT_ENCOURS),
        },
      ];
    },
  },
  methods: {
    getMontantForEtat(etatRenouvellement) {
      const lignesCommande = this.lignesCommande
        .filter((ligneCommande) => {
          return ligneCommande.devisCommande.etatRenouvellement === etatRenouvellement;
        });
      if (lignesCommande.length === 0) return 0;
      return lignesCommande.map(ligneCommande => ligneCommande.totalHtAvecLigneRemise)
        .reduce((montantTotal, montant) => montantTotal + montant);
    },
  },
};

</script>
